module.exports = __webpack_public_path__ + "static/media/large_tablet_frame.cece1a83.png";